module.exports = __webpack_public_path__ + "img/stripe.c8aeda16.svg";